/** Inicio de sesión */
export const INICIO_SESION      = "INICIO_SESION";
export const INICIO_CONEXION    = "INICIO_CONEXION";
export const ERROR_CONEXION     = "ERROR_CONEXION";
export const DETENER_CONEXION   = "DETENER_CONEXION";
export const CIERRE_SESION      = "CIERRE_SESION";
export const OBTENER_GUID       = 'OBTENER_GUID';
export const ERROR_GUID         = 'ERROR_GUID';
export const VALIDAR_SESION     = 'VALIDAR_SESION';
export const ERROR_CIERRE_SESSION   = 'ERROR_CIERRE_SESSION';